import React from 'react';
import classnames from 'classnames';
import ArtStageArrowLIcon from '@wix/da-ds/pkg/Icons/ArtStageArrowL';
import ArtStageArrowRIcon from '@wix/da-ds/pkg/Icons/ArtStageArrowR';
import s from './DeviationSlideshow.scss';
const Controls = ({ currentIndex, itemCount, onPrevClick, onNextClick })=>/*#__PURE__*/ React.createElement("nav", {
        className: s['controls']
    }, currentIndex > 0 && /*#__PURE__*/ React.createElement("button", {
        className: classnames(s['controls-button'], s['prev']),
        onClick: onPrevClick
    }, /*#__PURE__*/ React.createElement(ArtStageArrowLIcon, null)), currentIndex + 1 < itemCount && /*#__PURE__*/ React.createElement("button", {
        className: classnames(s['controls-button'], s['next']),
        onClick: onNextClick
    }, /*#__PURE__*/ React.createElement(ArtStageArrowRIcon, null)));
export default /*#__PURE__*/ React.memo(Controls);
